import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  IconButton,
  Chip,
  Box,
  Divider,
  Typography,
  Avatar,
  Popover,
  Tooltip,
  SvgIcon,
} from "@mui/material";
import {
  ChatBubbleOutlineOutlined,
  SettingsOutlined,
  CodeOutlined,
  CheckCircleOutlineOutlined,
  SmartToyOutlined,
  Build,
  School,
} from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import ProImg1 from "../../../../assets/images/AgentStar.svg";
import { Agent } from "../../../Types/Agent";
import { formatDate } from "../../../utils/Common/Common";
import { useNavigate } from "react-router-dom";
import {
  StartLoading,
  StopLoading,
} from "../../../Store/LoadingReducer/LoaderActions";
import { KNOWLEDGE_BASE, TOOLS } from "../../../../Services/Endpoint";
import { useDispatch } from "react-redux";
import BaseInstance from "../../../../Services/AxiosInstance/BaseInstance";
import { promises } from "dns";
import { KnowledgeBase } from "../../../Types/KnowledgeBase";
import { ShowError } from "../../../Store/MessageReducer/MsgActions";
import Tool from "../../../Types/Tool";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { Dialog, DialogTitle, DialogContent, Tabs, Tab } from "@mui/material";

import CreateEmbedForm from "../../../../Views/Components/EmbedDrawer/CreateForm";
// import { Embed } from "../../../../Shared-ui/Types/common";
import Embed from "../../../../Views/Components/Embed";
import Embedings from "../../../../Views/Components/EmbedDrawer/Embedings";
import MetaInstance from "../../../../Services/AxiosInstance/MetaInstance";
import { DELETE_EMBED, LIST_EMBED } from "../../../../Services/Endpoint";
import calendarIcon from "../../../../assets/images/calendarIcon.svg";
import CustomEmbedIcon from "../../../../assets/images/codeIcon.svg";

interface AgentCardProps {
  agent: Agent;
  deleteFun: (agent: Agent) => void;
  editFun: (agent: Agent) => void;
  hideDelete?: boolean;
  hideUpdate?: boolean;
}

const AgentCard: React.FC<AgentCardProps> = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [knowledgeBases, setKnowledgeBases] = useState<KnowledgeBase[]>([]);
  const [knowledgeBasesIds, setKnowledgeBasesIds] = useState<string[]>([]);
  const [tools, setTools] = useState<Tool[]>([]);
  const [toolsIds, setToolsIds] = useState<string[]>([]);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const open = Boolean(anchorEl);

  //const [toolAnchorEl, setToolAnchorEl] = useState<HTMLElement | null>(null);

  // const toolOpen = Boolean(toolAnchorEl);
  const [openEmbed, setOpenEmbed] = useState(false);

  useEffect(() => {
    const sortedCurrent = [...knowledgeBasesIds].sort();
    const sortedIncoming = [...props.agent.knowledge_base_ids].sort();

    const isEqual =
      sortedCurrent.length === sortedIncoming.length &&
      sortedCurrent.every((val, index) => val === sortedIncoming[index]);

    if (!isEqual) {
      setKnowledgeBasesIds(props.agent.knowledge_base_ids);
      getKnowledgeBases();
    }
  }, [props.agent.knowledge_base_ids]);

  useEffect(() => {
    const sortedCurrent = [...toolsIds].sort();
    const sortedIncoming = [...props.agent.tool_ids].sort();

    const isEqual =
      sortedCurrent.length === sortedIncoming.length &&
      sortedCurrent.every((val, index) => val === sortedIncoming[index]);

    if (!isEqual) {
      setToolsIds(props.agent.tool_ids);
      getTools();
    }
  }, [props.agent.tool_ids]);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleToolPopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setToolAnchorEl(event.currentTarget);
  };
  // const handleToolPopoverClose = () => {
  //   setToolAnchorEl(null);
  // };

  const getKnowledgeBases = async () => {
    try {
      dispatch(StartLoading());
      const kwPromises = props.agent.knowledge_base_ids.map((kwId) =>
        BaseInstance.get(`${KNOWLEDGE_BASE}/${kwId}`).then((res) => res?.data)
      );
      const data = await Promise.all(kwPromises);
      setKnowledgeBases(data);
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.statusText));
    } finally {
      dispatch(StopLoading());
    }
  };
  const getTools = async () => {
    try {
      dispatch(StartLoading());
      const toolPromises = props.agent.tool_ids.map((toolId) =>
        BaseInstance.get(`${TOOLS}/${toolId}`).then((res) => res?.data)
      );
      const data = await Promise.all(toolPromises);
      setTools(data);
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.statusText));
    } finally {
      dispatch(StopLoading());
    }
  };

  // Tools Popover
  const [toolAnchorEl, setToolAnchorEl] = useState<HTMLElement | null>(null);
  const toolOpen = Boolean(toolAnchorEl);
  const handleToolChipClick = (event: React.MouseEvent<HTMLElement>) => {
    if (tools.length > 0) setToolAnchorEl(event.currentTarget);
  };
  const handleToolPopoverClose = () => setToolAnchorEl(null);

  // Knowledge Popover
  const [knowledgeAnchorEl, setKnowledgeAnchorEl] =
    useState<HTMLElement | null>(null);
  const knowledgeOpen = Boolean(knowledgeAnchorEl);
  const handleKnowledgeChipClick = (event: React.MouseEvent<HTMLElement>) => {
    if (knowledgeBases.length > 0) setKnowledgeAnchorEl(event.currentTarget);
  };
  const handleKnowledgePopoverClose = () => setKnowledgeAnchorEl(null);

  return (
    <Card
      sx={{
        borderRadius: "12px",
        backgroundColor: "rgba(256, 256, 256, 0.7)",
        height: "100%",
        boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.1)",
        backdropFilter: "blur(5px)",
      }}
    >
      <CardContent sx={{ p: 2 }}>
        <Box display="flex" alignItems="center" gap={1.5}>
          <Avatar
            src={ProImg1}
            sx={{
              backgroundColor: "#04DB93",
              "& img": {
                objectFit: "none",
              },
            }}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              flexGrow: 1,
            }}
          >
            {props.agent.name.length > 38 ? (
              <Tooltip title={props.agent.name} placement="top-start">
                <Typography
                  variant="subtitle1"
                  fontWeight={500}
                  noWrap
                  sx={{
                    maxWidth: 250,
                    lineHeight: "20px",
                    textTransform: "capitalize",
                  }}
                >
                  {props.agent.name}
                </Typography>
              </Tooltip>
            ) : (
              <Typography
                variant="subtitle1"
                fontWeight={500}
                noWrap
                sx={{
                  maxWidth: 250,
                  lineHeight: "20px",
                  textTransform: "capitalize",
                }}
              >
                {props.agent.name}
              </Typography>
            )}

            <Typography
              variant="caption"
              noWrap
              sx={{
                maxWidth: 250,
                color: "#6E6E6E",
                textTransform: "capitalize",
              }}
            >
              {props.agent.model && props.agent.model.includes(":")
                ? props.agent.model.split(":")[1]
                : props.agent.model || ""}
            </Typography>
          </Box>
        </Box>
        {props.agent.description.length > 44 ? (
          <Tooltip title={props.agent.description} placement="top-start">
            <Typography
              variant="body1"
              color="text.secondary"
              mt={1}
              sx={{
                display: "-webkit-box",
                overflow: "hidden",
                textOverflow: "ellipsis",
                WebkitLineClamp: 1,
                WebkitBoxOrient: "vertical",
                minHeight: "22px",
              }}
            >
              {props.agent.description}
            </Typography>
          </Tooltip>
        ) : (
          <Typography
            variant="body1"
            color="text.secondary"
            mt={1}
            sx={{
              display: "-webkit-box",
              overflow: "hidden",
              textOverflow: "ellipsis",
              WebkitLineClamp: 1,
              WebkitBoxOrient: "vertical",
              minHeight: "22px",
            }}
          >
            {props.agent.description}
          </Typography>
        )}

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mt: 1,
          }}
        >
          <Box display="flex" alignItems="center" gap={1}>
            <Box display="flex">
              <img src={calendarIcon} />
            </Box>
            <Typography variant="body2" sx={{ color: "#6E6E6E" }}>
              {props.agent.created_at
                ? new Date(props.agent.created_at).toLocaleString(undefined, {
                  year: "numeric",
                  month: "short",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                })
                : ""}
            </Typography>
          </Box>
          {/* {props.agent.storage && (
            <Box display="flex" justifyContent="space-between" mt={0.5}>             
              <Typography variant="caption" fontWeight={500}>
                {props.agent.storage}
              </Typography>
            </Box>
          )} */}
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
          }}
        >
          {/* <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Box
              sx={{ display: "flex", alignItems: "center", gap: 1, width: 100 }}
            >
              <SmartToyOutlined sx={{ color: "#777", fontSize: 16 }} />
              <Typography
                variant="subtitle2"
                fontWeight="bold"
                color="text.secondary"
              >
                Model
              </Typography>
            </Box>
            <Chip
              label={props.agent.model}
              sx={{
                backgroundColor: /(gpt|gpt-4o)/i.test(props.agent.model)
                  ? "#E0ECFF"
                  : "#EAE2F8",
              }}
              size="small"
            />
          </Box> */}

          <Box
            sx={{ display: "flex", alignItems: "center", gap: 1, mt: "10px" }}
          >
            {/* Tools */}
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ mr: 0.5 }}
            >
              Tools:
            </Typography>
            <Chip
              size="small"
              label={
                props.agent.tool_ids.length > 0
                  ? `${props.agent.tool_ids.length} active`
                  : "Not selected"
              }
              onClick={handleToolChipClick}
              sx={{
                backgroundColor:
                  props.agent.tool_ids.length > 0 ? "#f5f7fa" : "#FFF8E1",
                color: props.agent.tool_ids.length > 0 ? "#222" : "#FFA000",
                fontSize: "12px",
                fontWeight: 400,
                textTransform: "capitalize",
                borderRadius: "16px",
                cursor: props.agent.tool_ids.length > 0 ? "pointer" : "default",
                "& .MuiChip-icon": {
                  marginLeft: "4px",
                },
              }}
              clickable={props.agent.tool_ids.length > 0}
            />
            <Popover
              open={toolOpen}
              anchorEl={toolAnchorEl}
              onClose={handleToolPopoverClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
            >
              <Box
                sx={{
                  p: 1,
                  minWidth: 250,
                  maxWidth: 250,
                  display: "flex",
                  gap: 1,
                  flexDirection: "column",
                  maxHeight: "96px",
                  overflowY: "auto",
                }}
              >
                {tools.map((tool, idx) => (
                  <Chip
                    key={tool.id || idx}
                    label={tool.name}
                    variant="outlined"
                    size="small"
                    sx={{
                      textTransform: "capitalize",
                      maxWidth: "100%",
                      "& .MuiChip-label": {
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: "block",
                      },
                    }}
                  />
                ))}
              </Box>
            </Popover>

            {/* Knowledge */}
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ ml: 2, mr: 0.5 }}
            >
              Knowledge:
            </Typography>
            <Chip
              size="small"
              label={
                props.agent.knowledge_base_ids.length > 0
                  ? `${props.agent.knowledge_base_ids.length} active`
                  : "Not selected"
              }
              onClick={handleKnowledgeChipClick}
              sx={{
                backgroundColor:
                  props.agent.knowledge_base_ids.length > 0
                    ? "#f5f7fa"
                    : "#FFF8E1",
                color:
                  props.agent.knowledge_base_ids.length > 0
                    ? "#222"
                    : "#FFA000",
                fontSize: "12px",
                fontWeight: 400,
                textTransform: "capitalize",
                borderRadius: "16px",
                cursor:
                  props.agent.knowledge_base_ids.length > 0
                    ? "pointer"
                    : "default",
                "& .MuiChip-icon": {
                  marginLeft: "4px",
                },
              }}
              clickable={props.agent.knowledge_base_ids.length > 0}
            />
            <Popover
              open={knowledgeOpen}
              anchorEl={knowledgeAnchorEl}
              onClose={handleKnowledgePopoverClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
            >
              <Box
                sx={{
                  p: 1,
                  minWidth: 250,
                  maxWidth: 250,
                  display: "flex",
                  gap: 1,
                  flexDirection: "column",
                  maxHeight: "96px",
                  overflowY: "auto",
                }}
              >
                {knowledgeBases.map((kb, idx) => (
                  <Chip
                    key={kb.id || idx}
                    label={kb.name}
                    variant="outlined"
                    size="small"
                    sx={{
                      textTransform: "capitalize",
                      maxWidth: "100%",
                      "& .MuiChip-label": {
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: "block",
                      },
                    }}
                  />
                ))}
              </Box>
            </Popover>
          </Box>
        </Box>
      </CardContent>

      <Divider />

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        px={2}
        py={1}
      >
        <Box display="flex" alignItems="center" gap={1.5}>

          {!(props.agent.knowledge_base_ids.length > 0 || props.agent.tool_ids.length > 0) ? (
            // Case 1: No knowledge base or tools → Setup Incomplete
            <Box display="flex" alignItems="center" gap={0.5}>
              <Box
                sx={{
                  width: "8px",
                  height: "8px",
                  borderRadius: "50%",
                  backgroundColor: "error.main",
                }}
              ></Box>
              <Typography variant="caption" color="error">
                Setup Incomplete
              </Typography>
            </Box>
          ) : !props.agent.is_active ? (
            // Case 2: Has tools/KB but is not active → Emble agent
            <Box display="flex" alignItems="center" gap={0.5}>
              <Box
                sx={{
                  width: "8px",
                  height: "8px",
                  borderRadius: "50%",
                  backgroundColor: "error.main",
                }}
              ></Box>
              <Typography variant="caption" color="error">
               Agent disabled
              </Typography>
            </Box>
          ) : (
            // Case 3: Has tools/KB and is active → Ready To Use
            <Box display="flex" alignItems="center" gap={0.5}>
              <Box
                sx={{
                  width: "8px",
                  height: "8px",
                  borderRadius: "50%",
                  backgroundColor: "#04db93",
                }}
              ></Box>
              <Typography variant="caption" color="#04db93">
                Ready To Use
              </Typography>
            </Box>
          )}
        </Box>

        {/* api key */}

        <Box display="flex">
          <Tooltip title="Chat with Agent">
            <IconButton
              disabled={knowledgeBases.length === 0 && tools.length === 0 || !props.agent.is_active}
              onClick={() => navigate(`/playground/agent/${props.agent.id}`)}
            >
              <ChatBubbleOutlineOutlined fontSize="small" />
            </IconButton>
          </Tooltip>

          {!props.hideUpdate && props.agent.user_permission && (
            <Tooltip title="Settings">
              <IconButton
                onClick={() => props.editFun(props.agent)}
                disabled={props.agent.user_permission === "read" ? true : false}
              >
                <SettingsOutlined fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
          {props.agent.user_permission && (
            <Tooltip title="Embed">
              <IconButton
                onClick={() => setOpenEmbed(true)}
                disabled={
                  props.agent.user_permission === "read" ||
                    (knowledgeBases.length === 0 && tools.length === 0)
                    ? true
                    : false
                }
                sx={{
                  width: "36px",
                  opacity:
                    props.agent.user_permission === "read" ||
                      (knowledgeBases.length === 0 && tools.length === 0)
                      ? 0.5
                      : 1,
                }}
              >
                <img src={CustomEmbedIcon} alt="Embed" />
              </IconButton>
            </Tooltip>
          )}

          {!props.hideDelete && props.agent.user_permission && (
            <Tooltip title="Delete Agent">
              <IconButton
                disabled={props.agent.user_permission === "read" ? true : false}
                onClick={() => props.deleteFun(props.agent)}
              >
                <DeleteOutlineOutlinedIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      </Box>

      {/* embed drawer */}
      {openEmbed && props.agent.id && (
        <Embed
          setOpenEmbed={setOpenEmbed}
          openEmbed={openEmbed}
          agentId={props.agent.id}
        />
      )}
    </Card>
  );
};

export default AgentCard;
